/** 企微入站事件时间线：中英双语标题与色调 */

export type InboundEventLabel = {
  /** 上排：事件 · 添加客户 */
  titleZh: string;
  /** 下排：change_external_contact · add_external_contact */
  titleEn: string;
  tone: "default" | "warning" | "recovery";
  /** 由调用方根据 contact.churned_at 与本事件是否刚流失决定；首版可仅按 change_type */
  churnSuffix?: boolean;
};

const CHANGE_ZH: Record<string, string> = {
  add_external_contact: "添加客户",
  edit_external_contact: "编辑客户信息",
  del_follow_user: "客户删除跟进人",
  del_external_contact: "员工删除客户",
  /** 客户群成员变更 */
  del_member: "成员退群",
  add_member: "成员入群",
};

const EVENT_ZH: Record<string, string> = {
  change_external_contact: "客户联系人变更",
  change_external_chat: "客户群变更",
};

export function labelWecomInboundEvent(
  event: {
    msg_type: string | null;
    event_type: string | null;
    change_type: string | null;
  },
  opts: { justMarkedChurned?: boolean; clearedChurn?: boolean } = {},
): InboundEventLabel {
  const change = event.change_type || "";
  const ev = event.event_type || "";
  const specificZh =
    CHANGE_ZH[change] || (ev ? EVENT_ZH[ev] || "客户联系人变更" : "未知变更");
  let titleZh = `事件 · ${specificZh}`;
  if (opts.justMarkedChurned) titleZh += " · 已标记流失";
  if (opts.clearedChurn) titleZh += " · 已恢复";

  const enParts = [ev, change].filter(Boolean);
  const titleEn = enParts.join(" · ");

  let tone: InboundEventLabel["tone"] = "default";
  if (change === "del_follow_user" || opts.justMarkedChurned) tone = "warning";
  if (opts.clearedChurn) tone = "recovery";

  return { titleZh, titleEn, tone };
}

type TimedChangeEvent = {
  id: number;
  change_type: string | null;
  wecom_created_at?: string | null;
  created_at?: string | null;
};

function eventTimeMs(event: TimedChangeEvent): number {
  const iso = event.wecom_created_at || event.created_at;
  if (!iso) return event.id;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? ms : event.id;
}

/**
 * 「已恢复」仅当本条 add 之前已有删跟进人/删客户事件（曾流失或断联后再加回）。
 * 不可用当前 contact.churned_at==null：首次添加后 churned_at 也是 null。
 */
export function inboundAddClearedChurn(
  event: TimedChangeEvent,
  siblings: TimedChangeEvent[],
): boolean {
  if (event.change_type !== "add_external_contact") return false;
  const addAt = eventTimeMs(event);
  return siblings.some((other) => {
    if (other.id === event.id) return false;
    const ct = other.change_type;
    if (ct !== "del_follow_user" && ct !== "del_external_contact") return false;
    const t = eventTimeMs(other);
    return t < addAt || (t === addAt && other.id < event.id);
  });
}
